// ============================================
// Creator Editor - Parser Module (ES6)
// firstMessage 파싱
// ============================================

// ============================================
// firstMessage 파싱
// ============================================

export function parseFirstMessageToBlocks(message, introImages = []) {
  if (!message) return [];

  const blocks = [];
  const markerRegex = /\{(N|C|T|U|I)\}([\s\S]*?)(?:\{\/(N|C|T|U|I)\}|(?=\{[NCTUI]\})|$)/g;
  let match;

  while ((match = markerRegex.exec(message)) !== null) {
    const type = match[1];
    let content = match[2].trim();
    if (content) {
      let blockType;
      if (type === 'N') blockType = 'narration';
      else if (type === 'C') blockType = 'dialogue';
      else if (type === 'T') blockType = 'thought';
      else if (type === 'U') blockType = 'user';
      else if (type === 'I') {
        blockType = 'image';
        if (/^\d+$/.test(content)) {
          const idx = parseInt(content, 10);
          content = introImages[idx] || content;
        }
      }
      else blockType = 'narration';

      blocks.push({ type: blockType, content });
    }
  }

  if (blocks.length === 0 && message.trim()) {
    blocks.push({ type: 'narration', content: message.trim() });
  }

  return mergeConsecutiveNarrations(blocks);
}

function mergeConsecutiveNarrations(blocks) {
  const merged = [];
  for (const block of blocks) {
    const prev = merged[merged.length - 1];
    if (prev?.type === 'narration' && block.type === 'narration') {
      prev.content += '\n\n' + block.content;
    } else {
      merged.push(block);
    }
  }
  return merged;
}
